// authSlice.js
import { createSlice } from '@reduxjs/toolkit';

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isLoggedIn: false,
        token: null,
        guestToken: null,
    },
    reducers: {
        loginSuccess: (state, action) => {
            state.isLoggedIn = true;
            state.token = action.payload;
            state.guestToken = null;
        },
        setGuestToken: (state, action) => {
            state.guestToken = action.payload;
        },
        logout: (state) => {
            state.isLoggedIn = false;
            state.token = null; // Clear the token during logout
            state.guestToken = null;
        },
    },
});

// Thunk to load token from local storage
export const loadToken = () => (dispatch) => {
    const token = localStorage.getItem('token');
    if (token) {
        // Dispatch loginSuccess with the loaded token
        dispatch(loginSuccess(token));
    }
};

export const loadGuestToken = () => (dispatch) => {
    const token = localStorage.getItem('guestToken');
    if (token) {
        // Dispatch loginSuccess with the loaded token
        dispatch(setGuestToken(token));
    }
};

export const { loginSuccess, logout, setGuestToken } = authSlice.actions;

// Selector to get the token from the state
export const selectToken = (state) => state.auth.token;
export const selectGuestToken = (state) => state.auth.guestToken;

export const selectIsLoggedIn = (state) => state.auth.isLoggedIn;


// Additional thunk for handling logout in components
export const handleLogout = () => (dispatch) => {
    dispatch(logout());
    // Clear the token from local storage
    localStorage.removeItem('token');
    localStorage.removeItem('guestToken');
    localStorage.removeItem('toggleStates');
};

export default authSlice.reducer;
